/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} General_Assign_SelectedInputs */

const en_general_assign_selected = /** @type {(inputs: General_Assign_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Assign selected items`)
};

const de_general_assign_selected = /** @type {(inputs: General_Assign_SelectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausgewählte Elemente zuweisen`)
};

/**
* | output |
* | --- |
* | "Assign selected items" |
*
* @param {General_Assign_SelectedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const general_assign_selected = /** @type {((inputs?: General_Assign_SelectedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<General_Assign_SelectedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_general_assign_selected(inputs)
	return de_general_assign_selected(inputs)
});